import { PlatformLayout } from "./platform-layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AiImportContent } from "./platform-ai-import";
import { OnboardingImportsContent } from "./platform-onboarding-imports";
import { BrainCircuit, Users } from "lucide-react";

export function ImportsContent() {
  return (
    <Tabs defaultValue="ai-import">
      <TabsList className="flex flex-wrap h-auto gap-1 mb-4">
        <TabsTrigger value="ai-import" data-testid="tab-imports-ai">
          <BrainCircuit className="h-4 w-4 mr-1.5" />
          AI Import
        </TabsTrigger>
        <TabsTrigger value="onboarding" data-testid="tab-imports-onboarding">
          <Users className="h-4 w-4 mr-1.5" />
          Client Onboarding
        </TabsTrigger>
      </TabsList>

      <TabsContent value="ai-import">
        <AiImportContent />
      </TabsContent>
      <TabsContent value="onboarding">
        <OnboardingImportsContent />
      </TabsContent>
    </Tabs>
  );
}

export default function PlatformImportsHub() {
  return (
    <PlatformLayout>
      <ImportsContent />
    </PlatformLayout>
  );
}
